'use strict';

// @ts-ignore
import qs from 'querystring';
import {Dictionary} from '../common';

export function parseUrlParams(params: string): Dictionary<any> {
    if (!params) {
        return {};
    }

    return qs.decode(params.substring(1));
}
